export const FILTER_BY_CAMPAIGNS = 'filter-by-campaigns';
export const SANKEY_CHART_DASHBOARD = 'sankey-chart-dashboard';
export const LIBRARY_SCREEN = 'library-screen';
export const ROOT_MENU = 'root-menu';
export const MESSAGE_WHALE = 'message-whale';
export const EXPORT_RECIPIENT_STATS = 'export-recipient-stats';
